// extracted by mini-css-extract-plugin
module.exports = {"spacer":"_27kpMcj","root":"_2oPY7bX","icon":"goe42Qk"};
    if(module.hot) {
      // 1545369457990
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  